/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPokeball = createReactComponent("pokeball", "IconPokeball", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M3 12h6", key: "svg-2" }],
  ["path", { d: "M15 12h6", key: "svg-3" }]
]);

export { IconPokeball as default };
//# sourceMappingURL=IconPokeball.js.map
